import { render, staticRenderFns } from "./Somos.vue?vue&type=template&id=efcb39aa&scoped=true&"
import script from "./Somos.vue?vue&type=script&lang=js&"
export * from "./Somos.vue?vue&type=script&lang=js&"
import style0 from "./Somos.vue?vue&type=style&index=0&id=efcb39aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efcb39aa",
  null
  
)

export default component.exports